import { type BranchKey, configurationKeys } from '@festina-life/api'
import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { Popover, PopoverButton } from '@festina-life/ui/structure'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'

import { ActionsMenuPanel } from '../../../actionsPanel/ActionsMenuPanel'
import { MergeBranchSelector } from './MergeBranchSelector'

type Props = {
  branchKey: BranchKey
}

export const MergeBranchButton = ({ branchKey }: Props) => {
  const translate = useTranslate()
  const [shouldRevalidateWorkspaces, setShouldRevalidateWorkspaces] =
    useState(false)
  const queryClient = useQueryClient()

  const handleMergePanelClosed = async () => {
    if (shouldRevalidateWorkspaces) {
      await queryClient.invalidateQueries({
        queryKey: [configurationKeys.allConciseWorkspacesKeyPrefix],
      })
    }
  }

  return (
    <Popover>
      <PopoverButton as="div">
        <Button startIcon="GitMerge">
          {translate('branchDetailsPanel.tabs.manage.merge')}
        </Button>
      </PopoverButton>
      <ActionsMenuPanel
        anchor={{ to: 'right' }}
        className="max-w-lg!"
        onClose={handleMergePanelClosed}
      >
        <MergeBranchSelector
          branchKey={branchKey}
          onDidMerge={setShouldRevalidateWorkspaces}
        />
      </ActionsMenuPanel>
    </Popover>
  )
}
